import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { StackDirectives } from '../../directives/stack-directives';
import { Router } from '@angular/router';

const ERROR_MESSAGES: Record<number, { message: string; details: string }> = {

  401: {
    message: 'No autorizado',
    details: 'No tienes permisos para acceder a esta sección. Por favor inicia sesión.'
  },
  403: {
    message: 'Acceso denegado',
    details: 'Esta sección no está disponible para tu usuario. Si crees que deberías tener acceso, comunícate con tu administrador.'
  },
  404: {
    message: 'No encontrado',
    details: 'El recurso solicitado no existe o fue eliminado.'
  },
  500: {
    message: 'Algo salió mal...',
    details: 'Estamos teniendo un problema técnico. Ya estamos trabajando para solucionarlo. Intenta de nuevo en unos minutos.'
  }
};

@Component({
  selector: 'app-error-modal',
  imports: [StackDirectives],
  templateUrl: './error-modal.component.html',
  styleUrl: './error-modal.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ErrorModalComponent {
  errorMessage: string;
  errorCode: number;
  errorDetails: string;

  constructor(
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: { statusCode: number; message?: string; details?: string }
  ) {
    const error = ERROR_MESSAGES[data.statusCode] || {
      message: 'Error desconocido',
      details: 'Ha ocurrido un error inesperado.'
    };
    this.errorMessage = data.message ?? error.message;
    this.errorDetails = data.details ?? error.details;
    this.errorCode = data.statusCode;
  }

  toLogin(): void {
    this.router.navigate(['/login']);
  }
}
